import { paymentTermActionTypes } from '@Actions/configurations/paymentTermActions';

const PaymentTermReducers = (state = { }, action) => {
  switch (action.type) {
  case paymentTermActionTypes.CREATE_PAYMENT_TERM.LOADING: {
    const { createPaymentTermLoading } = action;
    return {
      ...state,
      createPaymentTermLoading,
    };
  }
  case paymentTermActionTypes.GET_PAYMENT_TERMS.LOADING: {
    const { getPaymentTermsLoading } = action;
    return {
      ...state,
      getPaymentTermsLoading,
    };
  }
  case paymentTermActionTypes.GET_PAYMENT_TERMS.SUCCESS: {
    const { paymentTerms } = action;
    return {
      ...state,
      paymentTerms,
    };
  }
  case paymentTermActionTypes.UPDATE_PAYMENT_TERM.LOADING: {
    const { updatePaymentTermLoading } = action;
    return {
      ...state,
      updatePaymentTermLoading,
    };
  }
  case paymentTermActionTypes.DELETE_PAYMENT_TERM.LOADING: {
    const { deletePaymentTermLoading } = action;
    return {
      ...state,
      deletePaymentTermLoading,
    };
  }
  default: {
    return state;
  }
  }
};

export default PaymentTermReducers;
